import { Component, OnInit, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/services/encryption.service';
import { LoginService } from 'src/app/services/login.service';
import { SharedServices } from 'src/app/services/shared.service';

@Component({
  selector: 'app-agent-city',
  templateUrl: './agent-city.component.html',
  styleUrls: ['./agent-city.component.scss'],
  standalone: false
})
export class AgentCityComponent  implements OnInit {
  selectedCityId: number | null = null;
  isLoading: boolean = true;
  skeletonList: any[] = new Array(9);

  cityList: any[] = [
  ];

  constructor(
    @Optional() private dialogRef: MatDialogRef<AgentCityComponent>,
    private loginService: LoginService,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices
  ) { }

  ngOnInit() {
    this.selectedCityId = this.cityList[0]?.id ?? null;
    this.getAllActiveCities();
  }

  selectCity(city: any): void {
    this.selectedCityId = city.id;
    const details:any={
      City: String(city.id),
      UserId: parseInt(this.encryptionService.decryptUsingAES256(localStorage.getItem("a_n_d")))
    };
    // localStorage.setItem('selectedCity', this.encryptionService.encryptUsingAES256(JSON.stringify(city)));
    this.loginService.UpdateAgentCity(details).subscribe({
      next: (res: any) => {
        // this.closeDialog();
        const objectToStore = {
          id: city.id,
          name: city.name};
        localStorage.setItem('selectedCity', this.encryptionService.encryptUsingAES256(JSON.stringify(objectToStore)));
        this.sharedServices.setCityChanged(objectToStore);
        this.closeDialog();
      },
      error: (err: any) => {
      }
    });


    // const encryptedCity = this.encryptionService.encryptUsingAES256(city);
    // if (encryptedCity) {
    //   localStorage.setItem('selectedCity', encryptedCity);
    // }

  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  private getAllActiveCities(): void {
    this.loginService.GetAllActiveCities().subscribe({
      next: (res: any) => {
        const citySource = Array.isArray(res)
          ? res
          : res?.Cities ?? res?.Data ?? res?.Result ?? [];

        if (!Array.isArray(citySource) || citySource.length === 0) {
          this.isLoading = false;
          return;
        }

        this.cityList = citySource.map((item: any, index: number) => ({
          id: Number(item?.Id ?? item?.CityId ?? item?.id ?? index + 1),
          name: String(item?.CityName ?? item?.Name ?? item?.name ?? ''),
          imageUrl: String(item?.ImageURL ?? item?.ImageUrl ?? item?.imageUrl ?? 'https://example.com/images/city.jpg')
        })).filter((city: any) => city.name.trim().length > 0);
          this.loginService.GetAgentCity(parseInt(this.encryptionService.decryptUsingAES256(localStorage.getItem("a_n_d")))).subscribe({
        next: (res: any) => {
          if (res.CityId !=0) {
              this.selectedCityId = res.CityId;
          }
          this.isLoading = false;
         },
        error: (err: any) => {
          this.isLoading = false;
        }
      });

        // this.selectedCityId = this.cityList[0]?.id ?? null;
      },
      error: () => {
        // Keep static fallback list when API fails.
        this.isLoading = false;
      }
    });
  }

}
